/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUniqueDomId } from 'utils/getUniqueDomId';

const Input              = require('gui/inputs/input');

const __vue_script__ = {

  /** @since 3.8.6 */
  name:'input-checkbox',

  mixins: [Input],

  data() {
    return {
      value:   null,
      label:   null,
      id:      getUniqueDomId(), // new id
      /** @since 3.11.0 */
      changed: false,
    }
  },

  watch: {

    /**
     * ORIGINAL SOURCE: src/mixins/widget.js@3.10.4
     * 
     * @since 3.11.0
     */
    'state.value'(value) {
      if (this.changed) {
        this.changed = false
      } else {
        this.stateValueChanged(value);
      }
    },

  },

  methods: {

    /**
     * @see https://github.com/g3w-suite/g3w-admin/issues/958
     * 
     * @since 3.11.0
     */
    getValuesItem(checked = false) {
      return (this.service.state.input.options.values.find(v => !!checked === v.checked) || {});
    },

    /**
     * ORIGINAL SOURCE: src/mixins/widget.js@3.10.4
     *
     * @since 3.11.0
     */
    convertValueToChecked() {
      if ([null, undefined].includes(this.service.state.value)) {
        return false;
      }
      let option = this.service.state.input.options.values.find(v => this.service.state.value == v.value);
      if (undefined === option) {
        option = this.service.state.input.options.values.find(v => false === v.checked);
        this.service.state.value = option.value;
      }
      return option.checked;
    },

    changeCheckBox() {
      const { value, label } = this.getValuesItem(this.value);
      this.label             = label;
      this.state.value       = value;
      this.changed = true;
      this.change();
    },

    stateValueChanged() {
      this.value             = this.convertValueToChecked();
      const { value, label } = this.getValuesItem(this.value);
      this.label             = label;
      this.state.value       = value;
    },

  },

  mounted() {
    //Need to set label and value
    this.stateValueChanged();
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],staticStyle:{"height":"20px","margin-top":"8px"},attrs:{"slot":"body"},slot:"body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],class:{'input-error-validation' : _vm.notvalid},attrs:{"tabIndex":_vm.tabIndex,"type":"checkbox","id":_vm.id},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":[function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}},_vm.changeCheckBox]}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputCheckbox.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__